export const eur = (value, opts = {}) => {
  const n = Number(value || 0);
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: opts.decimals ?? 2,
    maximumFractionDigits: opts.decimals ?? 2,
  }).format(n);
};

export const eurShort = (value) => {
  const n = Number(value || 0);
  const abs = Math.abs(n);
  if (abs >= 1000) return `€${(n / 1000).toFixed(1)}k`;
  return `€${n.toFixed(0)}`;
};

export const pct = (value, decimals = 1) => `${Number(value || 0).toFixed(decimals)}%`;

export const signed = (value) => (Number(value) >= 0 ? "+" : "");
